import clsx from 'clsx';
import { Box, CircularProgress } from '@mui/material';

interface DataLoadingProps {
  loading: boolean;
  className?: string;
}

const DataLoading = ({ loading, className: customClassName }: DataLoadingProps) =>
  loading && (
    <Box
      className={clsx(customClassName)}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        maxHeight: 600,
      }}
    >
      <CircularProgress />
    </Box>
  );

export default DataLoading;
